import { Checkbox, Flex, useColorModeValue } from '@chakra-ui/react';
import React, { useState } from 'react';

import { finleyAssert } from '@finley-technologies/common';

import { AssetVerificationEditor } from './AssetVerificationEditor';
import {
  getCreditFacilityBySlug,
  getLoanProductBySlug,
  useGraph,
} from './GraphContext';
import { useGetTapeBuilderPipelineRunQuery } from 'packages/tapeBuilder/requests/tapeBuilder.gql.generated';
import { AssetVerificationEditorProps } from '~/packages/verifications/ui/AssetVerificationReceivablesTable/types';
import { VerificationAssetVerificationSection } from '~/packages/verifications/ui/VerificationAssetVerificationSection';

// this temporary component is meant for testing
// it allows us to call the api to fetch the receivable documentation on demand.
type Props = {
  pipelineRunId: string;
  creditFacilitySlug: string;
  loanProductSlug: string;
};
export const AssetVerificationTabPanel = ({
  pipelineRunId,
  creditFacilitySlug,
  loanProductSlug,
}: Props) => {
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const graphContext = useGraph();

  const { data: pipelineRun } = useGetTapeBuilderPipelineRunQuery({
    variables: {
      pipelineRunId,
    },
  });

  const creditFacilityId = getCreditFacilityBySlug(
    graphContext,
    creditFacilitySlug,
  );

  finleyAssert(
    creditFacilityId,
    `creditFacilityId must exist for given [creditFacilitySlug:${creditFacilitySlug}] for Asset Verification`,
  );

  const loanProductId = getLoanProductBySlug(graphContext, loanProductSlug);
  finleyAssert(
    loanProductId,
    `loanProductId must exist for given [loanProductSlug:${loanProductSlug}] for Asset Verification`,
  );

  const [
    selectedEditorProps,
    setSelectedselectedEditorProps,
  ] = useState<AssetVerificationEditorProps | null>(null);

  const [dynamicEvaluation, setDynamicEvaluation] = useState<boolean>(false);

  if (!pipelineRun) {
    return <Flex>Loading Pipeline Run Details</Flex>;
  }

  const {
    artifactDocumentId,
    reportingDate,
    fileVersion,
  } = pipelineRun.getPipelineRunById;
  return (
    <Flex
      flexDirection="column"
      width="100%"
      borderWidth="1px"
      borderStyle="solid"
      borderColor={borderColor}
      borderRadius="0.5rem"
      padding="1rem"
    >
      {!selectedEditorProps && (
        <>
          <Checkbox
            ml="2"
            isChecked={dynamicEvaluation}
            onChange={(e) => setDynamicEvaluation(e.target.checked)}
          >
            Dynamic Evaluation
          </Checkbox>
          <VerificationAssetVerificationSection
            artifactDocumentId={artifactDocumentId}
            creditFacilityId={creditFacilityId}
            loanProductId={loanProductId}
            reportingDate={reportingDate}
            fileVersion={fileVersion}
            onEdit={(props) => {
              setSelectedselectedEditorProps(props);
            }}
            adminMode
            dynamicMode={dynamicEvaluation}
          />
        </>
      )}
      {selectedEditorProps && (
        <AssetVerificationEditor
          {...selectedEditorProps}
          onClose={() => setSelectedselectedEditorProps(null)}
        />
      )}
    </Flex>
  );
};
